"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createDefaultBlockTypes: true,
  BalanceBlock: true,
  LayoutBlock: true,
  TemplateBlock: true,
  RepeatBlock: true,
  ConditionBlock: true,
  NftBlock: true,
  WalletBlock: true,
  ImageBlock: true,
  ContribTokenBlock: true,
  InputBlock: true,
  CheckboxBlock: true,
  SpinnerBlock: true,
  ContractBlock: true
};
Object.defineProperty(exports, "BalanceBlock", {
  enumerable: true,
  get: function () {
    return _BalanceBlock.BalanceBlock;
  }
});
Object.defineProperty(exports, "CheckboxBlock", {
  enumerable: true,
  get: function () {
    return _CheckboxBlock.CheckboxBlock;
  }
});
Object.defineProperty(exports, "ConditionBlock", {
  enumerable: true,
  get: function () {
    return _ConditionBlock.ConditionBlock;
  }
});
Object.defineProperty(exports, "ContractBlock", {
  enumerable: true,
  get: function () {
    return _ContractBlock.ContractBlock;
  }
});
Object.defineProperty(exports, "ContribTokenBlock", {
  enumerable: true,
  get: function () {
    return _ContribTokenBlock.ContribTokenBlock;
  }
});
Object.defineProperty(exports, "ImageBlock", {
  enumerable: true,
  get: function () {
    return _ImageBlock.ImageBlock;
  }
});
Object.defineProperty(exports, "InputBlock", {
  enumerable: true,
  get: function () {
    return _InputBlock.InputBlock;
  }
});
Object.defineProperty(exports, "LayoutBlock", {
  enumerable: true,
  get: function () {
    return _LayoutBlock.LayoutBlock;
  }
});
Object.defineProperty(exports, "NftBlock", {
  enumerable: true,
  get: function () {
    return _NftBlock.NftBlock;
  }
});
Object.defineProperty(exports, "RepeatBlock", {
  enumerable: true,
  get: function () {
    return _RepeatBlock.RepeatBlock;
  }
});
Object.defineProperty(exports, "SpinnerBlock", {
  enumerable: true,
  get: function () {
    return _SpinnerBlock.SpinnerBlock;
  }
});
Object.defineProperty(exports, "TemplateBlock", {
  enumerable: true,
  get: function () {
    return _TemplateBlock.TemplateBlock;
  }
});
Object.defineProperty(exports, "WalletBlock", {
  enumerable: true,
  get: function () {
    return _WalletBlock.WalletBlock;
  }
});
exports.createDefaultBlockTypes = createDefaultBlockTypes;
var _BlockTypeRegistry = require("./BlockTypeRegistry");
var _BalanceBlock = require("./type/BalanceBlock");
var _LayoutBlock = require("./type/LayoutBlock");
var _TemplateBlock = require("./type/TemplateBlock");
var _RepeatBlock = require("./type/RepeatBlock");
var _ConditionBlock = require("./type/ConditionBlock");
var _NftBlock = require("./type/NftBlock");
var _WalletBlock = require("./type/WalletBlock");
var _RepeatChildBlock = require("./type/RepeatChildBlock");
var _ImageBlock = require("./type/ImageBlock");
var _ContribTokenBlock = require("./type/ContribTokenBlock");
var _InputBlock = require("./type/InputBlock");
var _CheckboxBlock = require("./type/CheckboxBlock");
var _DumbappBlock = require("./type/DumbappBlock");
Object.keys(_DumbappBlock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DumbappBlock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappBlock[key];
    }
  });
});
var _SpinnerBlock = require("./type/SpinnerBlock");
var _ContractBlock = require("./type/ContractBlock");
function createDefaultBlockTypes() {
  return new _BlockTypeRegistry.BlockTypeRegistry().register("balance", _BalanceBlock.BalanceBlock).register("layout", _LayoutBlock.LayoutBlock).register("template", _TemplateBlock.TemplateBlock).register("repeat", _RepeatBlock.RepeatBlock).register("repeat-child", _RepeatChildBlock.RepeatChildBlock).register("condition", _ConditionBlock.ConditionBlock).register("nft", _NftBlock.NftBlock).register("wallet", _WalletBlock.WalletBlock).register("dumbapp", _DumbappBlock.DumbappBlock).register("spinner", _SpinnerBlock.SpinnerBlock).register("image", _ImageBlock.ImageBlock).register("contrib-token", _ContribTokenBlock.ContribTokenBlock).register("input", _InputBlock.InputBlock).register("checkbox", _CheckboxBlock.CheckboxBlock).register("contract", _ContractBlock.ContractBlock);
}
//# sourceMappingURL=types.js.map